import { Language } from '@/api/types';

const ALL_LANGUAGES: Language[] = ['english', 'spanish', 'russian', 'ukrainian'];

/**
 * The apply/client flow offers every supported language regardless of what the
 * positions list, and renders with whichever one the applicant selected. The
 * `positions` argument is kept for call-site compatibility but no longer
 * narrows the available set.
 */
export function useEffectiveLanguage(
  language: Language,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _positions?: ReadonlyArray<{ languages: Language[] }>
) {
  return {
    availableLanguages: ALL_LANGUAGES,
    effectiveLanguage: language,
  };
}
